import React from 'react';
import { generateKey } from '../../utils/utils.js'


class Paragraph extends React.Component {

  componentDidMount() {
  }

  render() {
    let content = this.props.content;
    let element = content.content.map((content,index) => {
        let value = content.value;        
        return content.nodeType === "text"  && content.value !== undefined && value.length > 1
            ? <p key={generateKey(index)}>{content.value}</p> 
            : content.nodeType === "hyperlink" ? <a key={generateKey(index)} target="_blank" href={content.data.uri}>{content.content[0].value}</a>
            : value.length > 1 ? <div key={generateKey(index)} class="spacer"></div> : null;
    });
    return element;
  }

}

export default Paragraph;
